// Lossless conversion between the stored/submitted `{{token}}`-in-HTML string
// (the format the backend substitutes + validates) and the TipTap WYSIWYG
// representation (prose + non-editable Token chip nodes).
//
//   load:  "{{token}}"-string  →  HTML the editor parses (chips for tokens)
//   save:  editor.getHTML()     →  "{{token}}"-string (chips → {{token}})
//
// The chip span carries `data-token="name"`; the Token node's parseHTML picks it
// up on load, and on save we swap each chip span back to its literal `{{name}}`.

const TOKEN_RE = /\{\{(\w+)\}\}/g

// Escape a token name into an HTML attribute value (token names are `\w+`, so
// this is belt-and-braces — there is nothing to escape — but kept explicit).
function escapeAttr(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

// Build the HTML the editor seeds from. Split the stored string on `{{token}}`:
// each match becomes a `<span data-token="name"></span>` (parsed into a Token
// chip node), and the prose between matches is passed through as-is so TipTap
// parses it as normal rich text.
export function contentToEditorHtml(content) {
  const src = content == null ? '' : String(content)
  let out = ''
  let last = 0
  let m
  TOKEN_RE.lastIndex = 0
  while ((m = TOKEN_RE.exec(src)) !== null) {
    out += src.slice(last, m.index)
    out += `<span data-token="${escapeAttr(m[1])}"></span>`
    last = m.index + m[0].length
  }
  out += src.slice(last)
  return out
}

// Serialise the editor's HTML back to the stored `{{token}}` string: parse the
// HTML, replace every chip span with its literal `{{name}}` text node, then read
// the result back out as HTML. Done via the DOM so the surrounding prose is
// preserved exactly as TipTap emitted it.
export function editorHtmlToContent(html) {
  const doc = new DOMParser().parseFromString(`<body>${html || ''}</body>`, 'text/html')
  doc.querySelectorAll('span[data-token]').forEach((span) => {
    const name = span.getAttribute('data-token')
    span.replaceWith(doc.createTextNode(`{{${name}}}`))
  })
  return doc.body.innerHTML
}
